import type { FeedQuestAction } from '@/views/Stream/types';

import type { ActionProps } from './Wrapper';

import { ChainUser } from './ChainUser';
import { ContractUser } from './ContractUser';
import { ProtocolDepositor } from './ProtocolDepositor';
import { DiscordMember } from './DiscordMember';
import { LinkVisit } from './LinkVisit';
import { NftHolder } from './NftHolder';
import { TelegramMember } from './TelegramMember';
import { TokenHolder } from './TokenHolder';
import { TwitterFollow } from './TwitterFollow';
import { TwitterQuote } from './TwitterQuote';
import { TwitterRetweet } from './TwitterRetweet';
import { DataImport } from './DataImport';

export const ActionContent: {
  [key in FeedQuestAction['type']]?: (props: ActionProps) => React.JSX.Element;
} = {
  chain_user: ChainUser,
  contract_user: ContractUser,
  protocol_depositor: ProtocolDepositor,
  discord_member: DiscordMember,
  link_visit: LinkVisit,
  nft_holder: NftHolder,
  telegram_member: TelegramMember,
  token_holder: TokenHolder,
  twitter_follow: TwitterFollow,
  twitter_quote: TwitterQuote,
  twitter_retweet: TwitterRetweet,
  google_sheet: DataImport,
  rest_api: DataImport,
};
